import { render, staticRenderFns } from "./curingSubcontract.vue?vue&type=template&id=52d20022&scoped=true&"
import script from "./curingSubcontract.vue?vue&type=script&lang=js&"
export * from "./curingSubcontract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d20022",
  null
  
)

export default component.exports